import { Layers } from 'lucide-react';

interface ImageCountSelectorProps {
  value: number;
  onChange: (value: number) => void;
  maxCount?: number;
}

const COUNT_OPTIONS = [
  { value: 1, label: '1张' },
  { value: 2, label: '2张' },
  { value: 3, label: '3张' },
  { value: 4, label: '4张' },
];

export function ImageCountSelector({ value, onChange, maxCount = 4 }: ImageCountSelectorProps) {
  const availableOptions = COUNT_OPTIONS.filter(option => option.value <= maxCount);

  return (
    <div>
      <label className="text-sm font-medium text-light-text mb-3 block flex items-center gap-2">
        <Layers className="w-4 h-4" />
        生成数量
      </label>
      <div className="flex gap-2">
        {availableOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            data-active={value === option.value}
            className="quality-btn flex-1"
          >
            {option.label}
          </button>
        ))}
      </div>
      <p className="text-xs text-light-muted mt-2">
        生成多张图片将消耗相应倍数的积分
      </p>
    </div>
  );
}
